import { render, staticRenderFns } from "./Res.vue?vue&type=template&id=4b894578&"
import script from "./Res.vue?vue&type=script&lang=js&"
export * from "./Res.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports